<template>
    <div class="policeList">
        <van-card>
            <template #title>
                <div class="title">
                    <div class="left"></div>
                    <div class="title_word" v-if="type === 1">{{ item.title }}</div>
                    <div class="title_word" v-else>{{ item.serviceName }}</div>
                </div>
            </template>
            <template #desc>
                <div class="bot">
                    <div class="type" v-if="type === 1">
                        政策类型:
                        <span>{{ item.classify1 }}</span>
                    </div>
                    <div class="type" v-else>服务范围:{{ item.minAge }}岁-{{ item.maxAge }}岁</div>
                    <div class="time" v-if="type === 1">发布时间:{{ item.pubDate.split(' ')[0] }}</div>
                    <div class="time" v-else>申请方式:{{ item.applyWay }}</div>
                    <div class="icon" v-if="type === 1">
                        <van-icon name="arrow" />
                    </div>
                </div>
            </template>
        </van-card>
    </div>
</template>

<script>
export default {
    name: "PoliceList",
    props: {
        item: {
            default: () => {
                return {};
            }
        },
        type: {
            type: Number,
            default: 1
        }
    }
};
</script>

<style lang="scss" scoped>
.policeList {
    .van-card {
      ::v-deep {
       .van-card__content {
         min-height: 0;
       } 
      }
        .title {
            display: flex;
            .left {
                width: 7px;
                height: 16px;
                background-color: #9cd9ff;
                border-radius: 0 3px 3px 0;
            }
            .title_word {
                margin-left: 10px;
                width: 300px;
                opacity: 1;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Bold;
                font-weight: 700;
                color: #543302;
            }
        }
        .bot {
            border-bottom: 4px solid #f3fafe;
            display: flex;
            justify-content: space-between;
            .type {
                opacity: 1;
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Bold;
                font-weight: 700;
                text-align: left;
                color: #757a8c;
                line-height: 50px;
                padding-left: 15px;
                span {
                    display: inline-block;
                    width: 60px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    vertical-align: top;
                }
            }
            .time {
                opacity: 1;
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Bold;
                font-weight: 700;
                text-align: left;
                color: #757a8c;
                line-height: 50px;
                padding-left: 15px;
            }
            .icon {
                font-size: 20px;
                color: rgba(154, 154, 154, 1);
                // padding-left: 80px;
            }
        }
    }
}
</style>
